import { render, staticRenderFns } from "./Plugins.vue?vue&type=template&id=c70dbfb6&scoped=true"
import script from "./Plugins.vue?vue&type=script&lang=js"
export * from "./Plugins.vue?vue&type=script&lang=js"
import style0 from "./Plugins.vue?vue&type=style&index=0&id=c70dbfb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70dbfb6",
  null
  
)

export default component.exports